import React from "react";
import { Link } from "react-router-dom";

import TopBar from "../../../../components/TopBar";
import TopBarProspectiveStudent from "../../../../components/ComponentsProspeciveStudentPage/TopBarProspectiveStudent";
import QuestionMashinostr from "../../../../components/ComponentsUndergraduatePage/ITE/ITEQuestion/QuestionMashinostr";
import Footer from "../../../../components/Footer";
import Container from "../../../../components/Container";

import img from "../../../../assets/images/EducationalPrograms/EducationalProgramsITE/davletbaev.jpg";
import doc from "../../../../assets/documents/uch-plan/materi.pdf";

import img1 from "../../../../assets/images/New/CEMCTeacher/info-block/info_block_img1.png";
import img2 from "../../../../assets/images/New/CEMCTeacher/info-block/info_block_img2.png";
import img3 from "../../../../assets/images/New/CEMCTeacher/info-block/info_block_img3.png";
import img4 from "../../../../assets/images/New/CEMCTeacher/info-block/info_block_img4.png";
import bg_left from "../../../../assets/images/New/CEMCTeacher/large-frame-bg1.svg";
import bg_right from "../../../../assets/images/New/CEMCTeacher/large-frame-bg2.svg";
import "./MaterialovedTeacherPage.css";

export default function MaterialovedTeacherPage() {

    return (
        <React.Fragment>
            <TopBar />
            <TopBarProspectiveStudent />
            <Container>
                <div className="educational-program teacher cemc">
                    <span className="teacher__title">Компьютерный инжиниринг в материаловедении
                    </span>
                    <div className="teacher__main-block">
                        <div className="teacher__main-block-img">
                            <img src={img} alt="" />
                        </div>
                        <div className="teacher__main-block-text">
                            <span className="teacher__text">Руководитель образовательной программы</span>
                            <span className="teacher__title">Давлетбаев Руслан Сагитович</span>
                            <span className="teacher__text">д.х.н., заведующий кафедрой <br />
                                «Материаловедение и технологии материалов»<br />
                                (МВТМ)</span>
                            <div className="teacher__main-block-text-row">
                                <span className="teacher__text">e-mail:</span>
                                <span className="teacher__text">mvtm2003@mail.ru</span>
                            </div>
                            <div className="teacher__main-block-text-row">
                                <span className="teacher__text">тел.:</span>
                                <span className="teacher__text">8 (843) 519-43-22</span>
                            </div>
                            <span className="teacher__text">420066, г. Казань, ул. Красносельская, 51,</span>
                            <div className="teacher__main-block-text-row">
                                <Link to="//priem.kgeu.ru/user/sign-in/login" className="teacher__button">Подать документы</Link>
                                {/* <Link to={doc} className="teacher__button" target="_blank">Узнать подробнее</Link> */}
                                <a href={doc} target="_blank" className="teacher__button">Учебный план </a>

                            </div>
                        </div>
                        <div className="teacher_exams" >

                            <span className="teacher__title" >Вступительные испытания</span>

                            {/* Обязательные предметы */}
                            <span className="teacher__text">Обязательные предметы</span>

                            <div className="subjects_group">
                                <div className="subject">
                                    <span className="Math" >М</span>
                                </div>
                                <div className="subject">
                                    <span className="Rus">Р</span>
                                </div>
                            </div>

                            {/* Предметы по выбору */}
                            <span className="teacher__text">Предметы по выбору</span>

                            <div className="subjects_group">
                                <div className="subject">
                                    <span className="Phys">Ф</span>
                                </div>
                                <div className="subject">
                                    <span className="Chem">Х</span>
                                </div>
                                <div className="subject">
                                    <span className="Eng">А</span>
                                </div>
                                <div className="subject">
                                    <span className="IT">И</span>
                                </div>
                            </div>

                            <span className="teacher__title">Проходной<br /> балл на 2023 г.</span>
                            <span className="passing_score">—</span>
                        </div>
                    </div>

                    <div className="teacher__info-block">

                        {/* Что я буду изучать? */}
                        <div className="info-block-frame" >
                            <span className="info_block-title">Что я буду изучать?</span>

                            <div className="info_block-text_area">

                                <div className="info_block-text-row">
                                    <span className="number">01</span>
                                    <span className="text-line">Новые полимерные материалы со<br /> специальными свойствами</span>
                                </div>
                                <div className="info_block-text-row">
                                    <span className="number">02</span>
                                    <span className="text-line">Технологии наномодифицирования <br />алюмосиликатного сырья</span>
                                </div>
                                <div className="info_block-text-row">
                                    <span className="number">03</span>
                                    <span className="text-line">Керамические и композиционные <br />материалы</span>
                                </div>
                                <div className="info_block-text-row">
                                    <span className="number">04</span>
                                    <span className="text-line">Диэлектрические свойстваv <br /> полиуретановых материалов</span>
                                </div>
                                <div className="info_block-text-row">
                                    <span className="number">05</span>
                                    <span className="text-line">Полимерные гель-электролиты для<br /> литий-ионных аккумуляторов</span>
                                </div>
                            </div>
                        </div>

                        {/* Кем я смогу работать? */}
                        <div className="info-block-frame" >
                            <span className="info_block-title">Кем я смогу работать?</span>
                            <div className="info_block-text_area">

                                <div className="info_block-text-row">
                                    <div className="info_block-text-row_img"><img src={img1} /></div>
                                    <span className="text-line">Инженером-конструктором</span>
                                </div>
                                <div className="info_block-text-row">
                                    <div className="info_block-text-row_img"><img src={img2} /></div>
                                    <span className="text-line">Специалистом-технологом по производству<br /> и обработке изделий</span>
                                </div>
                                <div className="info_block-text-row">
                                    <div className="info_block-text-row_img"><img src={img3} /></div>
                                    <span className="text-line">Специалистом обеспечивающий получение<br /> качественной продукции</span>
                                </div>
                                <div className="info_block-text-row">
                                    <div className="info_block-text-row_img"><img src={img4} /></div>
                                    <span className="text-line">Наладчиком технологического оборудования<br />  в производстве строительных материалов</span>
                                </div>
                            </div>

                        </div>
                    </div>
                    {/* Какие навыки я смогу получить? */}
                    <div className="teacher__info-block-frame-large">

                        <div className="wrap">
                            <img src={bg_left} />
                            <img src={bg_right} />
                        </div>
                        <span className="info_block-title">Какие навыки я смогу получить?</span>

                        <div className="frame-large-text-area">
                            <div className="frame-large-text-row">
                                <div className="info_block-text-row">
                                    <span className="number">01</span>
                                    <span className="text-line">Разрабока в области<br />
                                        нанотехнологии и<br /> инновационных технологий<br />
                                        спекания в керамике</span>
                                </div>

                                <div className="info_block-text-row">
                                    <span className="number">02</span>
                                    <span className="text-line">Сбор данных в области<br />
                                        проводимых экспериментов и <br />
                                        составление обзоров, отчетов и<br />
                                        научных публикаций</span>
                                </div>

                                <div className="info_block-text-row">
                                    <span className="number">03</span>
                                    <span className="text-line">Организация и оснащение<br /> трудовых мест</span>
                                </div>
                            </div>


                            <div className="frame-large-text-row last" >
                                <div className="info_block-text-row">
                                    <span className="number">04</span>
                                    <span className="text-line">Оформление проектной<br /> рабочей и технической<br /> документации, протоколов и<br />
                                        записей</span>
                                </div>

                                <div className="info_block-text-row">
                                    <span className="number">05</span>
                                    <span className="text-line">Разработка единого научного подхода, обеспечивающего системную<br />
                                        оценку комплексного влияния химического состава и типа химической<br />
                                        связи на структуру и наиболее общие характеристические свойства<br />
                                        гомо-и гетероядерных бинарных соединений</span>
                                </div>
                            </div>

                        </div>
                    </div>
                    {/* <span className="teacher__sub-block">Обучение ведется на русском языке</span>
                    <QuestionMashinostr /> */}
                </div>
            </Container>
            <Footer />
        </React.Fragment>

    );
}